function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* global */
import moment from 'moment';

/**
 * Unify format date on interface
 * @param  {int}    seconds  universal time seconds (1574871099 || 1.574871099663292E9)
 * @return (String) Time string for human
 *
 */
var filters = {};
filters.formatDate = function (seconds) {
  // The format date is UTC0, this is converted to NAV Date
  var date_string = null;
  try {
    // convert bigquery integer (//TODO: not match date for bigquery date)
    if (_typeof(seconds.match(/string/i)) && seconds.match(/E/)) {
      seconds = seconds.replace(/\./g, '').replace(/\d{3}E\d$/, '');
    }
    var date = new Date(parseInt(seconds));
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // La librería por defecto trabaja desde 0 a 11, se agrega el +1 para darle sentido al mes
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    date_string = "".concat(day, "-").concat(month, "-").concat(year, " ").concat(hours, ":").concat(minutes, ":").concat(second);
  } catch (e) {
    date_string = seconds;
  }
  return date_string;
};

/**
 * For unify and join project, dataset and table name
 * @param  {Object} obj       tableReference {projectIt, datasetId, tableId}
 * @param  {String} joinChar  Join caracters split
 * @return (String) String composed format name
 */
filters.joinTableReference = function (obj) {
  var joinChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
  try {
    var joinValues = "".concat(obj['projectId']).concat(joinChar).concat(obj['datasetId']).concat(joinChar).concat(obj['tableId']);
    return joinValues;
  } catch (e) {
    return obj;
  }
};

/**
 * Join object name
 * @param  {Object} obj       Any Dict object
 * @param  {String} joinChar  Join caracters split
 * @return (String) String composed fto print
 */
filters.joinObjectValues = function (obj) {
  var joinChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
  try {
    var keys = Object.keys(obj);
    var joinedKeys = [];
    for (var i = 0; i < keys.length; i++) {
      var val = obj[keys[i]];
      joinedKeys.push(val);
    }
    var joinValues = joinedKeys.join(joinChar);
    return joinValues;
  } catch (e) {
    return obj;
  }
};
filters.formatNumber = function (number) {
  var numberStr = number && number.toString();
  var numberFormated = numberStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  return numberFormated;
};
filters.formatPercent = function (number) {
  return (number * 100).toFixed(2);
};
filters.stringLongFormatDateStick = function (str) {
  return moment(new Date(str)).format('DD/MM/YYYY hh:mm');
};
filters.stringShortFormatDateStick = function (str) {
  return moment(new Date(str)).format('DD/MM/YYYY ');
};
export default filters;